//the initialize
angular.module('contactJobSeekerModule', ['ui.bootstrap', 'cacheManagerModule'])
    .service('confirmationService', [confirmationService])
    .controller('confirmationModalController', ['$scope', '$modalInstance', 'confirmationService', confirmationModalController])
    .service('contactJobSeekerService', ['$q', 'cacheManagerService', contactJobSeekerService])
    .controller('contactJobSeekerController', ['$q', '$scope', 'contactJobSeekerService', '$modal', contactJobSeekerController]);